import styled from 'styled-components';

export const UploadedImageContainer = styled.form`
  display: flex;
  background-color: ${({ theme }) => theme.colors.white};
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  border: 2px dashed gray;
  position: relative;
  border-radius: 5px;
  width: 100%;
  transition: 0.4s;
  padding: 40px;
  margin-top: 15px;
  box-sizing: border-box;
`;

interface ImageContainerProps {
  display?: 'flex' | 'inline-flex';
  flexDirection?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  alignContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'stretch'
    | 'space-between'
    | 'space-around'
    | 'normal';
  alignSelf?: 'stretch' | 'center' | 'start' | 'end';
  gap?: string;
  width?: string;
  height?: string;
  margin?: string;
  flex?: string;
  padding?: string;
  minHeight?: string;
  minWidth?: string;
  border?: string;
}

export const ImageContainer = styled.div<ImageContainerProps>`
  position: relative;
  width: ${({ width }) => (width ? width : undefined)};
  display: ${({ display }) => display || 'flex'};
  ${({ flexDirection }) => (flexDirection ? `flex-direction: ${flexDirection}` : undefined)};
  ${({ alignSelf }) => (alignSelf ? `align-self: ${alignSelf}` : undefined)};
  ${({ flexWrap }) => (flexWrap ? `flex-wrap: ${flexWrap}` : '')};
  ${({ justifyContent }) => (justifyContent ? `justify-content: ${justifyContent}` : undefined)};
  ${({ alignItems }) => (alignItems ? `align-items: ${alignItems}` : undefined)};
  ${({ alignContent }) => (alignContent ? `align-content: ${alignContent}` : undefined)};
  ${({ gap }) => (gap ? `gap: ${gap}` : undefined)};
  ${({ width }) => (width ? `width: ${width}` : undefined)};
  ${({ height }) => (height ? `height: ${height}` : undefined)};
  ${({ minHeight }) => (minHeight ? `min-height: ${minHeight}` : undefined)};
  ${({ margin }) => (margin ? `margin: ${margin}` : undefined)};
  ${({ flex }) => (flex ? `flex: ${flex}` : undefined)};
  ${({ padding }) => (padding ? `padding: ${padding}` : undefined)};
  ${({ minWidth }) => (minWidth ? `min-width: ${minWidth}px` : undefined)};
  border: ${({ border }) => border ?? 'unset'};
`;

export const IconCartContainer = styled.div`
  cursor: pointer;
  transition: 0.3s all;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  background-color: ${({ theme }) => theme.colors.white};
  position: absolute;
  top: 5px;
  right: 5px;
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.gray};
  &:hover {
    color: ${({ theme }) => theme.colors.red};
  }
`;

export const DropZoneContainer = styled.div`
  height: 230px;
  width: 100%;
  margin-top: 15px;
  cursor: pointer;

  & * {
    cursor: pointer;
  }
`;
